import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Divider,
  InputLabel,
  Box,
  makeStyles,
  Backdrop,
} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { gpColors } from "../../constants/colors";
import { useState } from "react";
import SideDrawer from "./Drawer";
import { useEffect } from "react";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import { routes } from "../../constants/routes";
import { getCookie } from "../../Functions";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";

const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "100vh",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    backgroundColor: "#EAE4E8",
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    height: "100%",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    //minWidth: 275,
    padding: "30px",
    minHeight: "280px",
    marginTop: "20px",
  },
  pos: {
    marginBottom: 12,
  },
  button: {
    textTransform: "none",
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
  },
  radioContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
    },
  },
  uploadContainer: {
    display: "flex",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  snackbar: {
    background: "green",
  },
}));
const Import = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [file, setFile] = useState({});
  const [userData, setUserData] = useState({});
  const inputRef = useRef();
  const [loader, setLoader] = useState(false);
  const [alert, setAlert] = useState("");
  const [snackbarColor, setSnackbarColor] = useState("");
  useEffect(() => {
    const getLoginInfoData = () => {
      const getValue = getCookie("guardPlus_user");
      if (getValue !== null) {
        const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
        const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
        console.log(userVal);
        setUserData(userVal);
      }
    };
    getLoginInfoData();
  }, []);

  const uploadFile = async (e) => {
    e.preventDefault();
    console.log(userData);
    const formData = new FormData();
    const inpFile = document.getElementById("file");
    formData.append("file", inpFile.files[0], inpFile.files[0].name);
    console.log("formData", inpFile.files[0]);
    console.log("inpFile.files[0].name", inpFile.files[0].name);
    console.log('formData', formData)
    // try{
    // const resp = await fetch(
    //   `http://ec2-52-7-249-236.compute-1.amazonaws.com:8081/setRecord`,
    //   {
    //     method: 'POST',
    //     body:formData,
    //     headers: {
    //       //'Access-Control-Allow-Origin': '*',
    //       // 'Content-Type': 'application/json',
    //       // Accept: 'application/json',
    //       "Content-Type": "multipart/form-data",
    //       Authorization:`Token ${userData.loginInfo.data.jwt}`
    //     },
    //   },
    // )
    // const data = await resp.json()
    // console.log(data)
    // }
    // catch(e){
    //  console.log(e.message)
    // }
    setLoader(true);
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_ENDPOINT}/setRecord`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${userData.loginInfo.data.jwt}`,
        },
      });
      console.log(response);
      if (response.status === 200) {
        setLoader(false);
        setAlert("File uploaded successfully!");
        setSnackbarColor("green");
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
      setAlert(e.message);
      setSnackbarColor("red");
    }
  };

  return (
    <div className={classes.roots}>
      <SideDrawer tabName="import" userData={userData} />
      <main className={classes.content}>
        <div className={classes.title}>Report</div>
        <Divider />

        <Card className={classes.root}>
          <CardContent>
            <form encType="multipart/form-data" onSubmit={(e) => uploadFile(e)}>
              {/* <div className={classes.radioContainer}>
              <InputLabel
                style={{
                  marginRight: '30px',
                  fontWeight: 700,
                  color: '#000',
                  paddingTop: '10px',
                  marginBottom: 10,
                }}
                required
              >
                choose an option
              </InputLabel>

              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="position"
                  name="position"
                  defaultValue="top"
                >
                  <FormControlLabel
                    value="sta"
                    control={<Radio color="primary" />}
                    label="With UOM conversion"
                  />
                  <FormControlLabel
                    value="end"
                    control={<Radio color="primary" />}
                    label="Without UOM conversion"
                  />
                </RadioGroup>
              </FormControl>
            </div> */}

              <div className={classes.uploadContainer}>
                <InputLabel
                  style={{
                    marginRight: "70px",
                    fontWeight: 700,
                    color: "#000",
                    marginBottom: 10,
                  }}
                  required
                >
                  Upload data
                </InputLabel>
                <Box
                  style={{
                    border: "1px solid gray",
                    padding: "10px",
                    marginRight: "12px",
                    marginBottom: "12px",
                  }}
                >
                  <input type="file" required id="file" />
                </Box>

                <Button type="submit" className={classes.button}>
                  {/* {loader?<CircularProgress size='23px'/> : 'Upload data'} */}
                  Import
                </Button>
              </div>
            </form>
          </CardContent>
          <Backdrop className={classes.backdrop} open={loader}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Card>
        <Snackbar
          ContentProps={{
            style: { background: snackbarColor },
          }}
          open={alert.length > 0}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={() => {
            setAlert("");
            setSnackbarColor("");
          }}
          message={alert}
        />
      </main>
    </div>
  );
};

export default Import;
